// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ft-scroll{flex:1}.ft-scroll>.el-scrollbar__wrap{overflow-x:hidden}", ""]);
// Exports
module.exports = exports;
